import React, { useState, useCallback } from 'react';
import './About.css';
import avatarAbout from '../../assets/avatar-about.png';
import resumePdf from '../../assets/Luigi Santiago Resume.pdf';
import linkedinIcon from '../../assets/socials/3d-icon-linkedin.png';
import githubIcon from '../../assets/socials/3d-icon-github.png';
import facebookIcon from '../../assets/socials/3d-icon-facebook.png';

// Certificate images & PDFs
import digitalAwarenessImg from '../../assets/certificate/digital-awareness.png';
import digitalAwarenessPdf from '../../assets/certificate/DigitalAwarenesLuigiSantiago.pdf';
import javaUnitTestingImg from '../../assets/certificate/Java Unit Testing.jpg';
import javaUnitTestingPdf from '../../assets/certificate/Java Unit Testing.pdf';
import springBootImg from '../../assets/certificate/Spring Boot 3 Spring 6 & Hibernate.jpg';
import springBootPdf from '../../assets/certificate/Spring Boot 3 Spring 6 & Hibernate.pdf';
import dockerImg from '../../assets/certificate/Docker.jpg';
import dockerPdf from '../../assets/certificate/Docker.pdf';
import javaMasterclassImg from '../../assets/certificate/Java Masterclass 2025.jpg';
import javaMasterclassPdf from '../../assets/certificate/Java Masterclass.pdf';
import gitImg from '../../assets/certificate/Git.jpg';
import gitPdf from '../../assets/certificate/Git.pdf';
import eclipseImg from '../../assets/certificate/Eclipse IDE.jpg';
import eclipsePdf from '../../assets/certificate/Eclipse IDE.pdf';
import mavenImg from '../../assets/certificate/Maven Crash Course.jpg';
import mavenPdf from '../../assets/certificate/Maven.pdf';
import angularImg from '../../assets/certificate/Angular.jpg';
import angularPdf from '../../assets/certificate/Angular.pdf';
import fullStackImg from '../../assets/certificate/The Complete Full-Stack Web Development Bootcamp.jpg';
import fullStackPdf from '../../assets/certificate/The Complete Full-Stack Web Development Bootcamp.pdf';
import vscodeImg from '../../assets/certificate/Udemy-VSCode.jpg';
import vscodePdf from '../../assets/certificate/Udemy-VSCode.pdf';
import udemyLogo from '../../assets/socials/udemy-transparent-logo-free-png.webp';

const certificates = [
  {
    id: 0,
    title: "Digital Awareness",
    image: digitalAwarenessImg,
    pdf: digitalAwarenessPdf,
    issuer: "Cisco",
    certificateId: "5555d288-8929-4a17-bf78-e44ec8a5c44e",
    credlyUrl: "https://www.credly.com/badges/5555d288-8929-4a17-bf78-e44ec8a5c44e",
    description: "Verified completion of Cisco's Digital Awareness program covering digital literacy and cybersecurity fundamentals.",
    skills: ["Digital Literacy", "Cybersecurity", "Network Safety"]
  },
  {
    id: 1,
    title: "Java Masterclass",
    image: javaMasterclassImg,
    pdf: javaMasterclassPdf,
    issuer: "Udemy",
    certificateId: "UC-83c2f48c-218c-4565-ba38-cd6b7c3c6903",
    description: "Comprehensive Java development mastery covering core syntax, OOP architecture, collections, and multi-threading.",
    skills: ["Java", "OOP", "Data Structures", "Algorithms"]
  },
  {
    id: 2,
    title: "Spring Boot 3, Spring 6 & Hibernate",
    image: springBootImg,
    pdf: springBootPdf,
    issuer: "Udemy",
    certificateId: "UC-c407d867-fae5-4dfa-84a6-4bfaed4e341d",
    description: "Enterprise backend development with Spring Boot 3, Spring Security, Hibernate ORM, and RESTful APIs.",
    skills: ["Spring Boot 3", "Hibernate", "REST APIs", "Spring Security"]
  },
  {
    id: 3,
    title: "Complete Full-Stack Web Development",
    image: fullStackImg,
    pdf: fullStackPdf,
    issuer: "Udemy",
    certificateId: "UC-708f2806-d22e-49ed-8f02-cc51aa059e98",
    description: "Comprehensive full-stack web bootcamp covering modern frontend, backend systems, database design, and deployments.",
    skills: ["Full-Stack", "JavaScript", "Node.js", "React"]
  },
  {
    id: 4,
    title: "Java Unit Testing (JUnit & Mockito)",
    image: javaUnitTestingImg,
    pdf: javaUnitTestingPdf,
    issuer: "Udemy",
    certificateId: "UC-a6c5dd1e-f05b-480b-ba46-cac41dde9e96",
    description: "Robust automated testing techniques with JUnit 5 and Mockito for maintainable test-driven Java codebases.",
    skills: ["JUnit 5", "Mockito", "TDD", "Integration Testing"]
  },
  {
    id: 5,
    title: "Git Version Control",
    image: gitImg,
    pdf: gitPdf,
    issuer: "Udemy",
    certificateId: "UC-a0cb8cc8-c490-4d16-b1c0-75e560dfa994",
    description: "Advanced Git workflows, branching strategies, collaborative merging, and repository management.",
    skills: ["Git", "GitHub", "Branching", "CI/CD Workflows"]
  },
  {
    id: 6,
    title: "Eclipse IDE",
    image: eclipseImg,
    pdf: eclipsePdf,
    issuer: "Udemy",
    certificateId: "UC-af6dc7c5-d7cb-4365-a304-e3a205d629e3",
    description: "Mastering development workflows, debugging tools, and build configuration in Eclipse IDE.",
    skills: ["Eclipse IDE", "Java Tooling", "Debugging"]
  },
  {
    id: 7,
    title: "Maven Crash Course",
    image: mavenImg,
    pdf: mavenPdf,
    issuer: "Udemy",
    certificateId: "UC-7e78a262-f149-4796-a1ac-4c155c5aae34",
    description: "Build automation, project lifecycle management, and dependency coordination using Apache Maven.",
    skills: ["Maven", "Build Automation", "Dependency Management"]
  },
  {
    id: 8,
    title: "Angular — The Complete Guide",
    image: angularImg,
    pdf: angularPdf,
    issuer: "Udemy",
    certificateId: "UC-ec207e2d-c600-4b2d-8532-9e3b9e7d025e",
    description: "Modern Single Page Application development with Angular, TypeScript, RxJS, and component architectures.",
    skills: ["Angular", "TypeScript", "RxJS", "SPA"]
  },
  {
    id: 9,
    title: "Docker for DevOps & Containers",
    image: dockerImg,
    pdf: dockerPdf,
    issuer: "Udemy",
    certificateId: "UC-98454763-f57d-4f77-99f5-c480a6c494ab",
    description: "Containerization fundamentals, Dockerfiles, multi-container orchestration, and deployment workflows.",
    skills: ["Docker", "Containerization", "DevOps", "Images"]
  },
  {
    id: 10,
    title: "Visual Studio Code Mastery",
    image: vscodeImg,
    pdf: vscodePdf,
    issuer: "Udemy",
    certificateId: "UC-28f46a6b-cd2f-412e-9cd4-8759896e824a",
    description: "Efficiency, extensions, debugging, and productivity workflows in modern VS Code environments.",
    skills: ["VS Code", "Tooling", "Productivity"]
  }
];

const experiences = [
  {
    period: "Jan 2025 — Apr 2025",
    role: "Intern — Frontend & Backend Developer",
    company: "Accenture Philippines",
    badge: "Academy Program",
    description: "Selected for the Academic Accenture Academy, developing full-stack projects using modern web technologies and obtaining multiple industry certifications.",
    highlights: [
      "Engineered feature modules and prototypes for modern web architectures",
      "Completed rigorous development masterclasses in cloud, containerization, and backend systems",
      "Collaborated in agile team sprints to deliver performant code"
    ],
    tech: ["Java", "Spring Boot", "Angular", "Docker", "Git"]
  },
  {
    period: "2023",
    role: "Salesforce Admin Trainee",
    company: "Salesforce",
    badge: "Trailhead",
    description: "Hands-on platform administration and CRM customization through Salesforce Trailhead.",
    highlights: [
      "Achieved 32 badges including 15 prestigious Superbadges",
      "Designed data models, custom validation rules, and automated workflow triggers",
      "Configured robust user access, permission sets, and security profiles"
    ],
    tech: ["Salesforce CRM", "Process Builder", "Data Security", "Workflows"]
  }
];

const educationList = [
  {
    period: "2021 — 2025",
    degree: "Bachelor of Science in Information Technology",
    school: "Bulacan State University",
    honors: "Dean's Lister & Best Capstone Nominee",
    details: "Specialized in Web and Mobile Application Development. Recognized as a top candidate for Best Capstone Project for BulSUFind."
  },
  {
    period: "2019 — 2021",
    degree: "Senior High School — STEM Strand",
    school: "Cabiao Senior High School",
    honors: "Graduated with Honors",
    details: "Active member in science research competitions and Mathematics & Science student organizations."
  },
  {
    period: "2015 — 2019",
    degree: "Junior High School",
    school: "Cabiao National High School",
    honors: "Graduated with Honors",
    details: "Consistent academic honors and active participation in school co-curricular clubs."
  }
];

const About = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [selectedCert, setSelectedCert] = useState(null);
  const [showAllCerts, setShowAllCerts] = useState(false);

  const openCertModal = useCallback((cert) => {
    setSelectedCert(cert);
  }, []);

  const closeCertModal = useCallback(() => {
    setSelectedCert(null);
  }, []);

  const displayedCerts = showAllCerts ? certificates : certificates.slice(0, 6);

  return (
    <section id="about" className="about-section">
      <div className="section-header">
        <span className="section-tag">About Me</span>
        <h2 className="section-title">Background & Milestones</h2>
        <p className="section-subtitle">
          A glimpse into my background, technical training, industry credentials, and academic journey.
        </p>
      </div>

      {/* Modern Tab Selector */}
      <div className="about-tab-bar">
        <button
          className={`about-tab-btn ${activeTab === 'about' ? 'active' : ''}`}
          onClick={() => setActiveTab('about')}
        >
          Story
        </button>
        <button
          className={`about-tab-btn ${activeTab === 'certificates' ? 'active' : ''}`}
          onClick={() => setActiveTab('certificates')}
        >
          Certifications ({certificates.length})
        </button>
        <button
          className={`about-tab-btn ${activeTab === 'experience' ? 'active' : ''}`}
          onClick={() => setActiveTab('experience')}
        >
          Experience
        </button>
        <button
          className={`about-tab-btn ${activeTab === 'education' ? 'active' : ''}`}
          onClick={() => setActiveTab('education')}
        >
          Education
        </button>
      </div>

      {/* Tab Content Container */}
      <div className="about-tab-container">
        {/* STORY TAB */}
        {activeTab === 'about' && (
          <div className="about-bento-grid">
            {/* Bio Card */}
            <div className="bento-card bio-card">
              <div className="bio-header">
                <img src={avatarAbout} alt="Luigi Santiago" className="bio-avatar" />
                <div>
                  <h3 className="bio-name">Luigi Santiago</h3>
                  <p className="bio-role">Software Developer • BSIT Graduate</p>
                </div>
              </div>
              <p className="bio-text">
                I am a passionate software developer driven by the pursuit of crafting robust, elegant, and high-performance digital products. My experience spans full-stack web platforms, native mobile development on Android, and scalable backend services with Java and Spring Boot.
              </p>
              <p className="bio-text">
                Whether solving complex algorithmic problems, building clean user interfaces, or integrating cloud architectures, I value clean code, strong performance, and continuous learning.
              </p>

              <div className="bio-actions">
                <a href={resumePdf} download="Luigi-Santiago-Resume.pdf" className="btn btn-primary">
                  Download Resume
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                </a>
                <div className="bio-socials">
                  <a href="https://github.com/Wigibles" target="_blank" rel="noopener noreferrer" className="social-pill" title="GitHub">
                    <img src={githubIcon} alt="GitHub" className="social-pill-icon" />
                  </a>
                  <a href="https://www.linkedin.com/in/luigiatlinkdin/" target="_blank" rel="noopener noreferrer" className="social-pill" title="LinkedIn">
                    <img src={linkedinIcon} alt="LinkedIn" className="social-pill-icon" />
                  </a>
                  <a href="https://www.facebook.com/luigisantiago231" target="_blank" rel="noopener noreferrer" className="social-pill" title="Facebook">
                    <img src={facebookIcon} alt="Facebook" className="social-pill-icon" />
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Metrics Cards */}
            <div className="bento-metrics-grid">
              <div className="bento-card metric-card">
                <span className="metric-number">4+</span>
                <span className="metric-title">Years of Coding</span>
                <p className="metric-desc">Hands-on software development across web, mobile, and system design.</p>
              </div>
              <div className="bento-card metric-card">
                <span className="metric-number">11+</span>
                <span className="metric-title">Industry Credentials</span>
                <p className="metric-desc">Certified in Java, Spring Boot, Docker, Git, and Full-Stack development.</p>
              </div>
              <div className="bento-card metric-card">
                <span className="metric-number">32+</span>
                <span className="metric-title">Salesforce Badges</span>
                <p className="metric-desc">Including 15 superbadges in security and workflow automation.</p>
              </div>
              <div className="bento-card metric-card">
                <span className="metric-number">BSIT</span>
                <span className="metric-title">BulSU Graduate</span>
                <p className="metric-desc">Specialized in Web & Mobile App Development with Dean's Honors.</p>
              </div>
            </div>
          </div>
        )}

        {/* CERTIFICATES TAB */}
        {activeTab === 'certificates' && (
          <div className="certificates-section">
            <div className="certificates-grid">
              {displayedCerts.map((cert) => (
                <div key={cert.id} className="cert-card" onClick={() => openCertModal(cert)}>
                  <div className="cert-top">
                    <div className="cert-issuer-badge">
                      {cert.issuer === 'Cisco' ? (
                        <span className="issuer-cisco">Cisco</span>
                      ) : (
                        <img src={udemyLogo} alt="Udemy" className="udemy-badge-logo" />
                      )}
                    </div>
                    <span className="cert-view-hint">View ↗</span>
                  </div>

                  <h3 className="cert-card-title">{cert.title}</h3>
                  <p className="cert-card-desc">{cert.description}</p>

                  <div className="cert-tags">
                    {cert.skills.slice(0, 3).map((skill, sIdx) => (
                      <span key={sIdx} className="cert-skill-tag">{skill}</span>
                    ))}
                  </div>

                  <div className="cert-card-footer">
                    <span className="cert-id-tag">ID: {cert.certificateId.slice(0, 10)}...</span>
                  </div>
                </div>
              ))}
            </div>

            {certificates.length > 6 && (
              <div className="certificates-toggle-wrap">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowAllCerts(!showAllCerts)}
                >
                  {showAllCerts ? 'Show Fewer' : `See All (${certificates.length}) Certificates`}
                </button>
              </div>
            )}
          </div>
        )}

        {/* EXPERIENCE TAB */}
        {activeTab === 'experience' && (
          <div className="timeline-container">
            {experiences.map((exp, idx) => (
              <div key={idx} className="timeline-item">
                <div className="timeline-node">
                  <div className="timeline-dot"></div>
                </div>
                <div className="timeline-card">
                  <div className="timeline-header">
                    <div>
                      <span className="timeline-period">{exp.period}</span>
                      <h3 className="timeline-title">{exp.role}</h3>
                      <p className="timeline-subtitle">{exp.company}</p>
                    </div>
                    <span className="timeline-badge">{exp.badge}</span>
                  </div>
                  <p className="timeline-description">{exp.description}</p>
                  <ul className="timeline-list">
                    {exp.highlights.map((item, hIdx) => (
                      <li key={hIdx}>{item}</li>
                    ))}
                  </ul>
                  <div className="timeline-tech-tags">
                    {exp.tech.map((t, tIdx) => (
                      <span key={tIdx} className="tech-pill">{t}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* EDUCATION TAB */}
        {activeTab === 'education' && (
          <div className="timeline-container">
            {educationList.map((edu, idx) => (
              <div key={idx} className="timeline-item">
                <div className="timeline-node">
                  <div className="timeline-dot"></div>
                </div>
                <div className="timeline-card">
                  <div className="timeline-header">
                    <div>
                      <span className="timeline-period">{edu.period}</span>
                      <h3 className="timeline-title">{edu.degree}</h3>
                      <p className="timeline-subtitle">{edu.school}</p>
                    </div>
                    {edu.honors && <span className="timeline-badge honors">{edu.honors}</span>}
                  </div>
                  <p className="timeline-description">{edu.details}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Certificate Modal */}
      {selectedCert && (
        <div className="cert-modal-backdrop" onClick={closeCertModal}>
          <div className="cert-modal-dialog" onClick={e => e.stopPropagation()}>
            <button className="cert-modal-close" onClick={closeCertModal} aria-label="Close modal">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            <div className="cert-modal-body">
              <div className="cert-modal-preview">
                <img src={selectedCert.image} alt={selectedCert.title} className="cert-modal-img" />
              </div>
              <div className="cert-modal-info">
                <span className="cert-modal-issuer">Issued by {selectedCert.issuer}</span>
                <h3 className="cert-modal-title">{selectedCert.title}</h3>
                <p className="cert-modal-desc">{selectedCert.description}</p>

                <div className="cert-modal-skills">
                  <span className="skills-heading">Skills Verified</span>
                  <div className="cert-tags">
                    {selectedCert.skills.map((skill, idx) => (
                      <span key={idx} className="cert-skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>

                <div className="cert-modal-actions">
                  <a
                    href={selectedCert.pdf}
                    download={`${selectedCert.title}.pdf`}
                    className="btn btn-primary"
                  >
                    Download Certificate PDF
                  </a>
                  {selectedCert.credlyUrl ? (
                    <a
                      href={selectedCert.credlyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      View on Credly ↗
                    </a>
                  ) : (
                    <a
                      href={`https://www.udemy.com/certificate/${selectedCert.certificateId}/`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                    >
                      Verify on Udemy ↗
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default About;